module.exports = __webpack_public_path__ + "static/img/241_TO8_2179.2cde7b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/241_TO8_2179.jpg
// module id = XCQR
// module chunks = 0